import { EventWithPayload } from '@/api/analytics';

export enum ServerMenu {
  // header
  Profile = 'profile',
  Lobby = 'lobby',
  Sports = 'sports',
  Promotions = 'promotions',
  Jackpot = 'jackpot',
  Tournaments = 'tournaments',
  VIP = 'VIP',
  MobileApp = 'mobileApp',
  Loyalty = 'loyalty',
  // footer
  Terms = 'terms',
  TermsEE = 'termsEE',
  BonusTerms = 'bonusTerms',
  BonusTermsEE = 'bonusTermsEE',
  PrivacyPolicy = 'privacyPolicy',
  PrivacyPolicyEE = 'privacyPolicyEE',
  CookiePolicy = 'cookiePolicy',
  ResponsibleGaming = 'responsibleGaming',
  ResponsibleGamingEE = 'responsibleGamingEE',
  PaymentMethods = 'paymentMethods',
  Affiliates = 'affiliates',
  Faq = 'faq',
  Complaints = 'complaints',
  AML = 'aml',
  ReferralProgram = 'referralProgram',
}

export enum ClientLinks {
  SportsLink = 'sportsLink',
}

export type ServerLink = {
  id: ServerMenu;
  url: string;
  hideConditions?: MenuClientHideConditions[];
  serverComponent: React.ReactNode;
  analyticsEventPayload?: EventWithPayload;
};

export enum MenuClientHideConditions {
  NotAuthenticated = 'notAuthenticated',
  IsEstonia = 'isEstonia',
  IsNotEstonia = 'isNotEstonia',
  IsIos = 'isIos',
  NoLoyaltyData = 'noLoyaltyData',
  isReferralPage = 'isReferralPage',
  IsAnyMobileApps = 'IsAnyMobileApps',
  IsAustralia = 'isAustralia',
}
